import axiosApi from '@/apis/axiosApi';
import { Permission } from '@/models/Permission';

const CHINA_REGIONAL_PLATFORM_API_URL = process.env.REACT_APP_CHINA_REGIONAL_PLATFORM_API_URL || 'regional-platform-api-dev';
export const getPermissions =  (): Promise<Permission> => {
  return axiosApi.post(CHINA_REGIONAL_PLATFORM_API_URL);
};
